import { Plugin } from '@nuxt/types'
import { Logger, createLogger } from '@/utils/logger'

declare module 'vue/types/vue' {
  interface Vue {
    $logger: Logger
  }
}

declare module '@nuxt/vue-app' {
  interface NuxtAppOptions {
    $logger: Logger
  }
}

declare global {
  interface Window {
    logger: Logger
  }
}

const plugin: Plugin = (context, inject) => {
  inject('logger', createLogger())
}

export default plugin
